module.exports = __webpack_public_path__ + "static/img/per15.c9a9545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per15.jpg
// module id = MDJT
// module chunks = 41